import { apiGet, apiPost } from 'api/service';

export function listNotifications(params = {}) {
  const query = new URLSearchParams(params).toString();
  return apiGet(`/api/notifications/${query ? `?${query}` : ''}`);
}

export function markNotificationRead(id) {
  return apiPost(`/api/notifications/${id}/mark_read/`, {});
}

export function markAllNotificationsRead() {
  return apiPost('/api/notifications/mark_all_read/', {});
}

export function clearNotifications() {
  return apiPost('/api/notifications/clear/', {});
}
